import React from 'react';
import { isLengthUnusual, UNUSUAL_SIZES } from '@shared/catchLength';

/**
 * True when a catch's length should be checked (#85): the server flagged it
 * (`lengthUnusual`, set by submit-catch / submit-catch-guest), or, for catches
 * submitted before the flag existed, its length is over the species' unusual
 * size.
 */
export function needsLengthCheck(c: { lengthUnusual?: boolean | null; species?: string | null; lengthCm?: number | null }): boolean {
  return c.lengthUnusual === true || isLengthUnusual(c.species, c.lengthCm);
}

/** "Check length" badge for adjudication screens. Renders nothing when not needed. */
const CheckLengthBadge: React.FC<{
  catchItem: { lengthUnusual?: boolean | null; species?: string | null; lengthCm?: number | null };
  className?: string;
}> = ({ catchItem, className = '' }) => {
  if (!needsLengthCheck(catchItem)) return null;
  const limit = catchItem.species ? UNUSUAL_SIZES[catchItem.species] : undefined;
  return (
    <span
      data-testid="check-length-badge"
      title={limit ? `Over ${limit}cm, unusual for this species. Check the brag mat photo.` : 'Unusual length. Check the brag mat photo.'}
      className={`inline-flex items-center gap-1 rounded-full bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-900 ${className}`}
    >
      📏 Check length
    </span>
  );
};

export default CheckLengthBadge;
